import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

/**
 * Provides a callback function which can be used to delete
 * @param url the url to delete from
 * @returns {{loading: boolean, error: boolean, deleteCallback: ((function(*=, *=): Promise<*>))}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occured.
 *
 * deleteCallback - the delete callback function, takes a body object and returns a promise which will contain json from the response.
 */
export function useFetchDeleteV2(url) {
  const { loading, error, fetchCallback } = useLazyFetchV2("DELETE");

  return {
    loading,
    error,
    deleteCallback: (body, headers = { "Content-Type": "application/json" }) =>
      fetchCallback(url, body, headers)
  };
}
